/**************************************************
 * Nombre:       Formulario_Curso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Flag} from "@mui/icons-material";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSCURSO, ESTADOSUSUARIOS} from "../../../Constantes";
import IngresoFecha from "../../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Curso = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={6}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={13} alto={6}/>
                    <Typography sx={{textAlign: 'center', width: '100%', fontSize: 12}}>Dimencion 1200x550 (max
                        300kb)</Typography>
                </Grid>

                <Grid container size={6}>
                    <IngresoImagenCrop dato={'imgCell'} {...props} ancho={4} alto={7}/>
                    <Typography sx={{textAlign: 'center', width: '100%', fontSize: 12}}>Dimencion 400x700 (max
                        300kb)</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSCURSO.map((it) => it.nombre)}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre del curso'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'} ejemplo={'Diplomado en conciliación en derecho'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Texto Avalado'} dato={'avalado'} {...props}
                                  ejemplo={'Avalado mediante Resolución No. 2288 del 26 de diciembre del 2023 Min de Justicia y del Derecho'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Segundo Titulo</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={2} nombre={'Certifiquese como: '} dato={'certifiquese'} {...props}
                                  requerido={'Campo requerido'} ejemplo={'Certifiquese como conciliador en derecho'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'De que le sirve el certificado'} dato={'para'} {...props}
                                  ejemplo={'Si es abogado quedará registrados cómo conciliadores ante el Ministerio de Justicia, si eres estudiante como capacitado para ejercer como conciliador cuándo cumplan los demás requisitos de la ley 2220 de 2022.'}
                    />
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoFecha dato={'fechaIncio'} nombre={'Fecha de Inicio'} {...props} />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Curso